<template>
  <detail-classifications :item="product" verbose="ce produit" ></detail-classifications>
</template>

<script>
import DetailClassifications from '@/components/DetailClassifications'

export default {
  name: 'ProductClassifications',
  components: { DetailClassifications },

  props: {
    product: Object
  }
}
</script>
